export interface IConfig {
  urls: {
    API_URL: string;
    WEBSOCKET_URL: string;
    API_UPLOAD_URL: string;
    API_FE_URL: string;
    API_HOST_ADDRESS: string;
    API_SSE_URL: string;
    STATUS_API_URL: string;
    BACKEND_URL: string;
  };
  web3: {
    PROJECT_ID: string;
    CMC_KEY: string;
    TOKEN_SLIPPAGE: number;
  };
  stripe: {
    PUBLIC_KEY: string;
  };
  referral: {
    MINIMUM_WITHDRAWAL_AMOUNT_IN_DOLLAR: number;
    REGISTRATION_LINK: string;
    RECAPTCHA_SITE_KEY: string;
  };
  compute: {
    MINIMUM_DEPOSIT: number;
    DISABLE_NEW_INSTANCE: boolean;
    LEASE_DURATION: string;
  };
}

export const SUPERNODERZ_API_URL =
  process.env.NEXT_PUBLIC_SUPERNODERZ_API_URL ||
  "https://api-dev.supernoderz.com";

export const NODE_ENV: string = process.env.NEXT_PUBLIC_APP_STAGE || "local";

const development: IConfig = {
  urls: {
    API_URL: "https://api-dev.spheron.network/v1",
    WEBSOCKET_URL: "wss://api-dev.spheron.network",
    API_UPLOAD_URL: "https://api-dev.spheron.network",
    API_FE_URL: "/api",
    API_HOST_ADDRESS:
      "https://supernoderz-app-git-protocol-dev-spheron.vercel.app",
    API_SSE_URL: "https://api-dev.spheron.network/subscribe",
    STATUS_API_URL: "https://status.spheron.network/api/v2/status.json",
    BACKEND_URL: SUPERNODERZ_API_URL,
  },
  web3: {
    PROJECT_ID: "caff53d8ca5738df1e0f0de17aed90d9",
    CMC_KEY: "0c5b25a6-4d37-4836-8b43-a6c575667cdd",
    TOKEN_SLIPPAGE: 0.01,
  },
  stripe: {
    PUBLIC_KEY:
      // eslint-disable-next-line max-len
      "pk_test_51MQy3GSFJddRcWmbnVfL8GVDuVqYV6uP0eL5UMpWZNC4kTE9aH5FtUw1OUDuc6cUPl3xzvVMxjSanU8fsE327Hva00WlmShVHE",
  },
  referral: {
    MINIMUM_WITHDRAWAL_AMOUNT_IN_DOLLAR: 0.1,
    REGISTRATION_LINK: "https://b4t4v7fj3cd.typeform.com/referral",
    RECAPTCHA_SITE_KEY: "6LcPoHsoAAAAAKSBuq6dKw0TnibY3MQNCWienNjw",
  },
  compute: {
    MINIMUM_DEPOSIT: 15,
    DISABLE_NEW_INSTANCE: false,
    LEASE_DURATION: "120min",
  },
};

const production: IConfig = {
  urls: {
    API_URL: "https://api-v2.spheron.network/v1",
    WEBSOCKET_URL: "wss://api-v2.spheron.network",
    API_UPLOAD_URL: "https://api-v2.spheron.network",
    API_FE_URL: "/api",
    API_HOST_ADDRESS: "https://www.supernoderz.com",
    API_SSE_URL: "https://api-v2.spheron.network/subscribe",
    STATUS_API_URL: "https://status.spheron.network/api/v2/status.json",
    BACKEND_URL: SUPERNODERZ_API_URL,
  },
  web3: {
    PROJECT_ID: "caff53d8ca5738df1e0f0de17aed90d9",
    CMC_KEY: "0c5b25a6-4d37-4836-8b43-a6c575667cdd",
    TOKEN_SLIPPAGE: 0.01,
  },
  stripe: {
    PUBLIC_KEY:
      // eslint-disable-next-line max-len
      "pk_live_51NAvgxL7rDi2tBajNDIw3siIbDcaAziwBuJndlMlxuwESn2zckxcls35GYOZNoVd7Vam5icwEyAdLmmnvLwIqFk700JdlzAzCV",
  },
  referral: {
    MINIMUM_WITHDRAWAL_AMOUNT_IN_DOLLAR: 100,
    REGISTRATION_LINK: "https://b4t4v7fj3cd.typeform.com/referral",
    RECAPTCHA_SITE_KEY: "6LcPoHsoAAAAAKSBuq6dKw0TnibY3MQNCWienNjw",
  },
  compute: {
    MINIMUM_DEPOSIT: 15,
    DISABLE_NEW_INSTANCE: false,
    // LEASE_DURATION: '1mon',
    LEASE_DURATION: "120min",
  },
};

const local: IConfig = {
  urls: {
    API_URL: "http://localhost:8080/v1",
    WEBSOCKET_URL: "ws://localhost:8080",
    API_UPLOAD_URL: "http://localhost:8002",
    API_FE_URL: "/api",
    API_HOST_ADDRESS: "http://localhost:3003",
    API_SSE_URL: "http://localhost:8080/subscribe",
    STATUS_API_URL: "https://status.spheron.network/api/v2/status.json",
    BACKEND_URL: SUPERNODERZ_API_URL,
  },
  web3: {
    PROJECT_ID: "caff53d8ca5738df1e0f0de17aed90d9",
    CMC_KEY: "0c5b25a6-4d37-4836-8b43-a6c575667cdd",
    TOKEN_SLIPPAGE: 0.01,
  },
  stripe: {
    PUBLIC_KEY:
      // eslint-disable-next-line max-len
      "pk_test_51MQy3GSFJddRcWmbnVfL8GVDuVqYV6uP0eL5UMpWZNC4kTE9aH5FtUw1OUDuc6cUPl3xzvVMxjSanU8fsE327Hva00WlmShVHE",
  },
  referral: {
    MINIMUM_WITHDRAWAL_AMOUNT_IN_DOLLAR: 0.1,
    REGISTRATION_LINK: "https://b4t4v7fj3cd.typeform.com/referral",
    RECAPTCHA_SITE_KEY: "6LcPoHsoAAAAAKSBuq6dKw0TnibY3MQNCWienNjw",
  },
  compute: {
    MINIMUM_DEPOSIT: 15,
    DISABLE_NEW_INSTANCE: false,
    LEASE_DURATION: "120min",
  },
};

const config: {
  [name: string]: IConfig;
} = {
  local,
  development,
  production,
};

export default config[NODE_ENV];

export interface INetwork {
  chainId: number;
  chainName: string;
  rpcUrls: string[];
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorerUrls: string[];
}

export type NetworkType = "testnet" | "mainnet";

export const networkType: NetworkType =
  (process.env.NEXT_PUBLIC_NETWORK_TYPE as NetworkType) || "mainnet";

export const RPC_MAP = {
  testnet: {
    HTTP:
      process.env.NEXT_PUBLIC_RPC_URL ||
      "https://base-sepolia.g.alchemy.com/v2/vN6ZeMQVQEjbGURcN5_vD_oVFQ_u6pQ9",
    WSS:
      process.env.NEXT_PUBLIC_WSS_URL ||
      "wss://base-sepolia.g.alchemy.com/v2/vN6ZeMQVQEjbGURcN5_vD_oVFQ_u6pQ9",
  },
  mainnet: {
    HTTP:
      process.env.NEXT_PUBLIC_BASE_MAINNET_RPC_URL ||
      "https://base-mainnet.g.alchemy.com/v2/Hhg_Epr1tyxiwJKDXFeKf",
    WSS:
      process.env.NEXT_PUBLIC_BASE_MAINNET_WSS_URL ||
      "wss://base-mainnet.g.alchemy.com/v2/Hhg_Epr1tyxiwJKDXFeKf",
  },
};

export const PAYMASTER_MAP = {
  testnet: {
    BUNDLER:
      "https://api.developer.coinbase.com/rpc/v1/base-sepolia/OlwSXlGt6RGtNhGXxOSP2ctoIvH3Cv1P",
    PAYMASTER:
      "https://api.developer.coinbase.com/rpc/v1/base-sepolia/OlwSXlGt6RGtNhGXxOSP2ctoIvH3Cv1P",
  },
  mainnet: {
    BUNDLER:
      "https://api.developer.coinbase.com/rpc/v1/base/OlwSXlGt6RGtNhGXxOSP2ctoIvH3Cv1P",
    PAYMASTER:
      "https://api.developer.coinbase.com/rpc/v1/base/OlwSXlGt6RGtNhGXxOSP2ctoIvH3Cv1P",
  },
};

export const networkMap: Record<NetworkType, INetwork> = {
  testnet: {
    chainId: 84532,
    chainName: "Base Sepolia",
    rpcUrls: [RPC_MAP.testnet.HTTP],
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://sepolia.basescan.org/"],
  },
  mainnet: {
    chainId: 8453,
    chainName: "Base Mainnet",
    rpcUrls: [RPC_MAP.mainnet.HTTP],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://basescan.org/"],
  },
};

export const SPHERON_PROXY_URL =
  process.env.PROVIDER_PROXY_URL || "https://provider-proxy.sphn.xyz";

export const LEASE_MONITORING_API_URL =
  process.env.LEASE_MONITORING_API_URL ||
  "https://lease-monitor.supernoderz.com";

export const KMS_SERVICE_URL =
  process.env.KMS_SERVICE_URL || "https://operators-manager.supernoderz.com";

export const subgraphUrl = {
  testnet:
    "https://api.goldsky.com/api/public/project_cm16apa2e540c01wz70x34xzf/subgraphs/sph-base-sepolia-new/1.0.0/gn",
  mainnet:
    "https://api.goldsky.com/api/public/project_cm16apa2e540c01wz70x34xzf/subgraphs/sph-base-mainnet/1.0.2/gn",
};

export const SUBGRAPH_API_KEY = process.env.NEXT_PUBLIC_SUBGRAPH_API_KEY || "";

export const USPON_WALLET_PRIVATE_KEY =
  process.env.USPON_WALLET_PRIVATE_KEY || "";

export const DISABLE_DEPLOYMENT =
  process.env.NEXT_PUBLIC_DISABLE_DEPLOYMENT === "true";

export const DISABLED_NODES =
  JSON.parse(process.env.NEXT_PUBLIC_DISABLED_NODES || "[]").map(
    (node: string) => node.toLowerCase()
  ) || [];

export const UNDER_MAINTENANCE_NODES =
  JSON.parse(process.env.NEXT_PUBLIC_UNDER_MAINTENANCE_NODES || "[]").map(
    (node: string) => node.toLowerCase()
  ) || [];

export const DISABLE_LOGIN = process.env.NEXT_PUBLIC_DISABLE_LOGIN === "true";

export const DISABLE_DEPOSIT =
  process.env.NEXT_PUBLIC_DISABLE_DEPOSIT === "true";

export type IDeploymentMode = "provider" | "fizz";

export const providerProxyWsUrl =
  process.env.PROVIDER_PROXY_URL?.replace("https", "wss") ||
  "wss://provider-proxy.sphn.xyz";

export const MAX_RESTART_ATTEMPTS = 3;

export const tokens = [
  { label: "USD", value: "usd" },
  { label: "SPON", value: "spon" },
];

export const DISABLE_SPON = process.env.NEXT_PUBLIC_DISABLE_SPON === "true";
